import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GREEN, BLUE, ORANGE, HeroMockup } from "./shared";

export function LandingHero() {
  return (
    <section className="relative overflow-hidden" data-testid="hero">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true"
        style={{ background: "linear-gradient(120deg, #F2F9F5 0%, #FAFBFA 45%, #EFF3F8 100%)" }} />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-28 grid lg:grid-cols-2 gap-12 items-center">
        <div className="lp-reveal">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08]"
            style={{ fontFamily: "Manrope, sans-serif" }} data-testid="hero-title">
            <span style={{ color: GREEN }}>L'ESG della tua impresa.</span>
            <br />
            <span style={{ color: BLUE }}>Finalmente semplice.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl" data-testid="hero-subtitle">
            ESG-PMI raccoglie, organizza e trasforma i dati della tua azienda in informazioni ESG
            utilizzabili per VSME, banche, clienti e filiere.
          </p>
          <p className="mt-3 text-base font-semibold" style={{ color: GREEN }}>
            Tu inserisci i dati che conosci. ESG-PMI pensa al resto.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/richiedi-demo"
              className="inline-flex items-center gap-2 text-sm font-bold px-6 py-3.5 rounded-md text-white transition-transform hover:-translate-y-0.5"
              style={{ background: ORANGE }} data-testid="cta-hero-start">
              Inizia il percorso ESG <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </Link>
            <a href="#soluzione"
              className="inline-flex items-center gap-2 text-sm font-semibold px-6 py-3.5 rounded-md border-2 transition-colors"
              style={{ borderColor: BLUE, color: BLUE }} data-testid="cta-hero-how">
              Scopri come funziona
            </a>
          </div>
          <p className="mt-5 text-xs text-slate-500">
            Pensata per micro, piccole e medie imprese. Nessuna competenza ESG richiesta.
          </p>
        </div>
        <HeroMockup />
      </div>
    </section>
  );
}
